import axiosInstance from './http';

function logAndRethrow(endpoint, error) {
    if (error?.response) {
        console.error(`[commentApi] ${endpoint} -> ${error.response.status}`, {
            url: error.response.config?.url,
            method: error.response.config?.method,
            params: error.response.config?.params,
            data: error.response.data,
            headers: error.response.headers,
        });
    } else {
        console.error(`[commentApi] ${endpoint} -> network/error`, error);
    }
    throw error;
}

export default {
    // GET /api/comments/?target=customer|facility|work|contract&id=123
    async list({ target, id, page } = {}) {
        const params = {};
        if (target) params.target = target;
        if (id) params.id = id;
        if (page) params.page = page;
        try {
            const response = await axiosInstance.get('comments/', { params });
            return response.data; // { count, results }
        } catch (error) {
            logAndRethrow('GET comments/', error);
        }
    },

    // POST /api/comments/  { body, target, id }
    async create({ body, target, id }) {
        try {
            const response = await axiosInstance.post('comments/', { body, target, id });
            return response.data;
        } catch (error) {
            logAndRethrow('POST comments/', error);
        }
    },

    // DELETE /api/comments/{id}/delete/
    async remove(commentId) {
        try {
            await axiosInstance.delete(`comments/${commentId}/delete/`);
            return true;
        } catch (error) {
            logAndRethrow(`DELETE comments/${commentId}/delete/`, error);
        }
    }
};